<div class="col-sm animated fadeIn fast" *ngIf="route.children.length === 0" >
  <div class="container-options">
    <h1 style="margin: 0px; padding: 0px;">
      Categorías Padre
    </h1>
      
    <button 
      mat-stroked-button 
      color="accent" 
      class="button-categories" 
      [routerLink]="['/categories/add']"
    >
      Agregar categoría padre
      <mat-icon>add_circle</mat-icon>
    </button>  
  </div>
  
  <app-categories
          [columns]="displayedColumns"
          [category]="'category'"
  ></app-categories>
</div>
<router-outlet></router-outlet>
